export default "__VITE_ASSET__2c88b8ff__"